/// <reference path="./detect.rechnerdetails.d.ts" />
/*!
 * @preserve
 * Detect.js
 * BrowserInfoCollector Frontend JS for dein-ip-check.de (Modul: detectSystem->detectRechnerDetails)
 *
 * @version 3.1.6
 * @author Jens Dutzi <jens.dutzi@tf-network.de>
 * @website http://www.dein-ip-check.de
 * @license Unauthorized copying of this file, via any medium is strictly prohibited Proprietary and confidential
 */

import DateTimeFormatOptions = Intl.DateTimeFormatOptions;

/**
 * Interface-Definition für das PluginObject
 * welches die Informationen eines Plugins beinhaltet
 */
export interface PluginObject {
    pluginName:string;
    pluginDetails:string;
}


export class detectRechnerDetails {
    /**
     * Aktuelle Zeitzone ermitteln inkl. IE10-Fallback
     */
    public static getTimezone() {
        let timezone, now;

        try {
            // Zeitzone in modernen Browsern ermitteln
            now = new Date();
            let options: DateTimeFormatOptions = { "timeZoneName":"long", "year": 'numeric', "month": "2-digit", "day" : "2-digit" };
            if(DETECTLANGUAGE === 'de') {
                timezone = now.toLocaleDateString("de-DE", options).match(/^([\d.-/]{10}, )(.*)$/i)[2];
            } else {
                timezone = now.toLocaleDateString("en-GB", options).match(/^([\d.-/]{10}, )(.*)$/i)[2];
            }
        } catch (e) {
            // IE11-Fallback: da timeZOneName im IE11 nicht unterstützt wird.
            now = new Date().toString();
            timezone = now.indexOf('(') > -1 ?
                now.match(/\([^)]+\)/)[0].match(/[A-Z]/g).join('') :
                now.match(/[A-Z]{3,4}/)[0];
            if (timezone === "GMT" && /(GMT\W*\d{4})/.test(now)) {
                timezone = RegExp.$1;
            } else if (timezone === "UTC" && /(UTC\W*\d{4})/.test(now)) {
                timezone = RegExp.$1;
            }
        }

        return timezone;
    }

    /**
     * Uhrzeit aktualisieren
     *
     * @param dateField
     * @param timeField
     */
    public static startUpdateClock(dateField: JQuery<HTMLElement>, timeField: JQuery<HTMLElement>): boolean {
        // Uhrzeit aktualisieren
        let updateClock = function() {
            let currentTime = new Date();
            let dateOptions: DateTimeFormatOptions = { year: 'numeric', month: '2-digit', day: '2-digit' };
            if(DETECTLANGUAGE === 'de') {
                $(dateField).html( currentTime.toLocaleDateString("de-DE", dateOptions) );
                $(timeField).html( currentTime.toLocaleTimeString("de-DE", { hour: '2-digit', minute: '2-digit', second: '2-digit' }) );
            } else {
                $(dateField).html( currentTime.toLocaleDateString("en-US", dateOptions) );
                $(timeField).html( currentTime.toLocaleTimeString("en-US", { hour: 'numeric', minute: '2-digit', second: '2-digit' }) );
            }
        };

        // Timer starten
        if(new Date() !== null) {
            updateClock();
            setInterval(updateClock, 1000);
        } else {
            return false;
        }

        return true;
    }

    /**
     * Touchpanel vorhanden?
     *
     * @return boolean
     */
    public static getTouchscreenStatus(): boolean {
        return (('ontouchstart' in window)
            || (navigator.maxTouchPoints > 0)
            || (navigator.msMaxTouchPoints > 0));
    }

    /**
     * Ermittle die Systemsprache soweit möglich und expandiere Sie durch ein serverseitiges PHP Script
     *
     * @return string
     */
    public static getSystemLanguage(systemLanguageField: JQuery<HTMLElement>) {
        // Sprache ermitteln
        let languageCode: string;
        if (typeof window.navigator.systemLanguage !== "undefined") {
            languageCode = window.navigator.systemLanguage;
        } else if (typeof window.navigator.browserLanguage !== "undefined") {
            languageCode = window.navigator.browserLanguage;
        } else if (typeof window.navigator.userLanguage !== "undefined") {
            languageCode = window.navigator.userLanguage;
        } else {
            languageCode = window.navigator.language;
        }

        try {
            let requestData = {
                locales: languageCode
            };

            $.post(AJAXENDPOINT + "/translate", requestData, function (result) {
                // Ergebnis erhalten
                if (typeof result.languageString !== "undefined") {
                    languageCode = result.languageString;
                }
            }).fail(function (jqXhr, textStatus, errorThrown) {
                console.warn("Fehler beim erkennen der Systemsprache: " + textStatus);
                console.warn(errorThrown);
            }).then(function() {
                systemLanguageField.text(languageCode);
            });
        } catch (e) {
            console.warn("Fehler beim erkennen der Systemsprache: " + e);
            systemLanguageField.text(languageCode);
        }
    }

    /**
     * Prüfe ob es sich um ein 64-Bit System handelt (32-Bit kann nicht zuverlässig erkannt werden - z.B. bei MacIntel)
     * @returns {string}
     */
    public static getSystemArchitecture(): any {
        //Scan the User Agent for a specific string
        let scanUA = function(str: string) {
            //If the string is contained in the User Agent return true
            return window.navigator.userAgent.indexOf(str) > -1;
        };

        let platform = window.navigator.platform;
        let  className;

        if (
            scanUA('x86_64') ||
            scanUA('x86-64') ||
            scanUA('Win64') ||
            scanUA('x64;') ||
            scanUA('amd64') ||
            scanUA('AMD64') ||
            scanUA('WOW64') ||
            scanUA('x64_64') ||
            platform === 'MacIntel' ||
            platform === 'Linux x86_64'
        ) {
            // Dieses Vorkommen in der Plattform-Kennung/Useragent spricht für 64-Bit
            className = '64 Bit';
        } else if (
            platform === 'Linux armv7l' ||
            platform === 'iPad' ||
            platform === 'iPhone' ||
            platform === 'Android' ||
            platform === 'iPod' ||
            platform === 'BlackBerry'
        ) {
            // Dieses Vorkommen in der Plattform-Kennung/Useragent spricht für eine ARM-CPU
            className = 'ARM CPU';
        } else if ( platform === 'Linux i686' ) {
            // Dieses Vorkommen kann nicht erfolgreich ausgewertet werten
            className = '-- Bit';
        } else {
            // Rest wird als 32-Bit gemeldet
            className = '32 Bit';
        }

        return className;
    }

    public static updateOrientation(): string {
        let displayStr;
        // noinspection JSDeprecatedSymbols
        switch (window.orientation) {
            case 0:
                displayStr = DETECTPHRASE["Vertikal"];
                break;
            case -90:
                displayStr = DETECTPHRASE["Horizontal (rechts, im Uhrzeigersinn)"];
                break;
            case 90:
                displayStr = DETECTPHRASE["Horizontal (links, gegen den Uhrzeigersinn)"];
                break;
            case 180:
                displayStr = DETECTPHRASE["Vertikal (auf dem Kopf stehend)"];
                break;
            default:
                displayStr = DETECTPHRASE["nicht ermittelbar"];
        }

        return displayStr;
    }

    /**
     * Ermittle Bildschirm-Auflösung
     *
     * @returns {string}
     */
    public static getScreenSize(): string {
        let outputScreensize:string;
        if (screen.width !== null) {
            outputScreensize = screen.width.toString();
        } else {
            outputScreensize = "?";
        }
        outputScreensize = outputScreensize + " x ";
        if (screen.height !== null) {
            outputScreensize = outputScreensize + screen.height.toString();
        } else {
            outputScreensize = "?";
        }
        outputScreensize = outputScreensize + " Pixel";
        if (screen.colorDepth !== null) {
            outputScreensize = outputScreensize + " / " + screen.colorDepth + " Bit";
        }

        return outputScreensize;
    }

    /**
     * Ermittle die Fenstergröße
     *
     * @returns {string}
     */
    public static getWindowSize(): string {
        let windowWidth: any,
            windowHeight: any,
            output: string;

        // Abhängig vom Browser die Fenstergröße ermitteln
        if (isNaN(window.innerHeight) !== true) {
            // Code für Sonstige Browser
            if (window.innerWidth > screen.width) {
                windowWidth = screen.width;
            } else {
                windowWidth = window.innerWidth;
            }
            if (window.innerHeight > screen.height) {
                windowHeight = screen.height;
            } else {
                windowHeight = window.innerHeight;
            }
        } else if (isNaN(document.body.offsetWidth) !== true) {
            // Code for Microsoft Internet Explorer
            let ieBreite = (document.compatMode && document.compatMode.toString() === "CSS1Compat") ? document.documentElement.offsetWidth : document.body.offsetWidth;
            let ieHoehe = (document.compatMode && document.compatMode.toString() === "CSS1Compat") ? document.documentElement.offsetHeight : document.body.offsetHeight;
            if (ieBreite > screen.width) {
                windowWidth = screen.width;
            } else {
                windowWidth = ieBreite;
            }
            if (ieHoehe > screen.height) {
                windowHeight = screen.height;
            } else {
                windowHeight = ieHoehe;
            }
        } else {
            windowHeight = null;
            windowWidth = null;
        }

        // Ausgabe zusammenstellen
        if (windowWidth === null) {
            output = "?";
        } else {
            output = windowWidth.toString();
        }
        output = output + " x ";
        if (windowHeight === null) {
            output = output + "?";
        } else {
            output = output + windowHeight.toString();
        }
        output = output + " Pixel";

        return output;
    }

    /**
     * Verfügbarkeit von Flash prüfen
     *
     * @param FlashDetectorURL string
     * @param success function
     * @param failed function
     */
    public static getFlashStatus(FlashDetectorURL: string, success: Function, failed: Function): void {
        const detectFlash = require('detect-flash').default;

        detectFlash(FlashDetectorURL)
            .then(
                () => success(),
                () => failed()
            );
    }

    /**
     * Java-Plugin vorhanden?
     *
     * @param success
     * @param failed
     */
    public static getJavaStatus(success: Function, failed: Function): void {
        // Java Status ermitteln
        if (navigator.javaEnabled()) {
            success();
        } else {
            failed();
        }
    }

     /* Plugin Liste
     *
     * @return {Array}
     */
    public static getPluginList(): object[] | null {
        let pluginCount = navigator.plugins.length;
        let last = "";
        let arrPluginList = [];

        if (pluginCount > 0) {
            for (let i = 0; i < pluginCount; i++) {
                // Work-Around für gelegentliche doppelte Listung des letzten Plugins in Webkit-Browser
                if (last !== navigator.plugins[i].name) {
                    let pluginOutput = [];
                    last = navigator.plugins[i].name;
                    let pluginName = navigator.plugins[i].name.replace(/(<([^>]+)>)/ig, "");
                    if (typeof navigator.plugins[i].description !== "undefined") {
                        if (navigator.plugins[i].description !== "") pluginOutput.push("<i>" + navigator.plugins[i].description.replace(/(<([^>]+)>)/ig, "") + "</i>");
                    }
                    if (typeof navigator.plugins[i].version !== "undefined") {
                        if (navigator.plugins[i].version !== "") pluginOutput.push("Version: <i>" + navigator.plugins[i].version.replace(/(<([^>]+)>)/ig, "") + "</i>");
                    }
                    if (typeof navigator.plugins[i].filename !== "undefined") {
                        if (navigator.plugins[i].filename !== "") pluginOutput.push("Datei: <i>" + navigator.plugins[i].filename.replace(/(<([^>]+)>)/ig, "") + "</i>");
                    }

                    let result: PluginObject = {
                        "pluginName" : pluginName,
                        "pluginDetails" : pluginOutput.join("<br />")
                    };

                    arrPluginList.push(result);
                } else {
                    pluginCount--;
                }
            }
            return arrPluginList;
        } else {
            return null;
        }
    }
}
